export const API_TIMEOUT = 1000 * 600;

export const TABLE_MIN_COLUMN_WIDTH = 50;
export const EUR = '€';
export const TEST_EMAIL = 'redacted.email,';
